module.exports = __webpack_public_path__ + "static/media/preloader-Big-FC-withText-Pet.a39b3879.gif";